module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-chapter"
  }, [(!_vm.external || _vm.external.length === 0) ? _c('div', {
    staticClass: "loader"
  }, [_vm._v("\n    " + _vm._s(_vm.$t("lesson.external-game.loading")) + "\n    "), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center",
      "display": "flex",
      "justify-content": "center",
      "margin": "8px"
    }
  }, [_c('SlinkyVue')], 1)]) : _vm._e(), _vm._v(" "), (_vm.intro) ? _c('LessonHeader', {
    staticClass: "lessonOnTop",
    style: (_vm.safeTopVar),
    attrs: {
      "outerData": _vm.game.name,
      "externalType": _vm.game.game_type
    },
    on: {
      "closeIntro": _vm.closeIntro
    }
  }) : _vm._e(), _vm._v(" "), (_vm.loading) ? _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("\n\n    " + _vm._s(_vm.$t("lesson.external-game.loading-game")) + "\n    "), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center",
      "display": "flex",
      "justify-content": "center",
      "margin": "8px"
    }
  }, [_c('SlinkyVue')], 1)]) : _vm._e(), _vm._v(" "), (_vm.intro) ? _c('OnBoardingModal', {
    attrs: {
      "type": "game",
      "text": _vm.intro_text,
      "audioSrc": _vm.intro_audio,
      "imgSrc": _vm.intro_image,
      "vidSrc": _vm.intro_video,
      "id": _vm.id
    },
    on: {
      "clicked": _vm.clicked
    }
  }) : (_vm.external) ? _c('div', {
    staticClass: "chapter-course"
  }, _vm._l((_vm.external), function(section) {
    return _c('div', {
      key: section.name,
      staticClass: "collapsed",
      style: ({
        height: _vm.calculateHeight(section)
      })
    }, [_c('div', {
      staticClass: "lesson-type",
      on: {
        "click": function($event) {
          return _vm.pickType(section)
        }
      }
    }, [_c('div', [_c('div', [_c('h5', [_vm._v(_vm._s(section["name"]))])])]), _vm._v(" "), _c('div', {
      staticClass: "arrow"
    }, [_c('inline-svg', {
      class: _vm.pickedType == section ? 'upside-arrow' : 'down-arrow',
      attrs: {
        "src": require('../../assets/svg/arrow-down.svg').default
      }
    })], 1)]), _vm._v(" "), _c('div', {
      staticClass: "lesson-wrapper"
    }, _vm._l((section.games), function(game) {
      return _c('div', {
        key: game.id,
        staticClass: "step",
        class: {
          completed: _vm.userGames.includes(game.id)
        },
        on: {
          "click": function($event) {
            return _vm.getGame(game)
          }
        }
      }, [_c('div', {
        staticClass: "v-stepper-course"
      }, [_c('div', {
        staticClass: "circle"
      }, [(_vm.userGames.includes(game.id)) ? _c('inline-svg', {
        staticClass: "check-v-ex",
        attrs: {
          "src": require('../../assets/svg/GreenCheck.svg').default
        }
      }) : _vm._e()], 1), _vm._v(" "), (
        game.permission !== 'unknown' &&
        game.permission !== _vm.permission &&
        _vm.permission !== 'paying'
      ) ? _c('div', {
        staticClass: "lesson-icon"
      }, [(
        game &&
        game.permission !== 'unknown' &&
        game.permission !== _vm.permission &&
        _vm.permission !== 'paying'
      ) ? _c('inline-svg', {
        staticClass: "lockSign",
        attrs: {
          "width": "14px",
          "height": "14px",
          "src": require('../../assets/svg/lock.svg').default
        }
      }) : _vm._e(), _vm._v(" "), (
        game &&
        game.permission !== 'unknown' &&
        game.permission !== _vm.permission &&
        _vm.permission !== 'paying' &&
        game.permission == 'registered'
      ) ? _c('inline-svg', {
        attrs: {
          "width": "14px",
          "height": "14px",
          "src": require('../../assets/svg/googleicon.svg').default
        }
      }) : _vm._e()], 1) : _vm._e()]), _vm._v(" "), _c('div', {
        staticClass: "gameText",
        class: {
          gameContent: true,
          disbaledText: game.permission !== 'unknown' &&
            game.permission !== _vm.permission &&
            _vm.permission !== 'paying'
        }
      }, [_vm._v("\n            " + _vm._s(game.name) + "\n          ")])])
    }), 0)])
  }), 0) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1afa99d9","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Lesson/external-game.vue
// module id = 318
// module chunks = 0 7